// The rain archive's offset-free timestamps are Europe/Rome wall-clock times.
// Explicit offsets (rolling 24–120h) preserve the actual DST-aware window.
const romanParts = new Intl.DateTimeFormat('sv-SE', {timeZone:'Europe/Rome',year:'numeric',month:'2-digit',day:'2-digit',hour:'2-digit',minute:'2-digit',second:'2-digit',hourCycle:'h23'});
function wallTime(value) {
    if (typeof value !== 'string' || !value.trim()) return NaN;
    let text=value.trim();
    if (/(?:Z|[+-]\d{2}:?\d{2})$/i.test(text)) {
        const time=Date.parse(text);
        if (!Number.isFinite(time)) return NaN;
        const p=Object.fromEntries(romanParts.formatToParts(time).map(x=>[x.type,x.value]));
        return Date.UTC(+p.year,+p.month-1,+p.day,+p.hour,+p.minute,+p.second);
    }
    const m=text.match(/^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2})(?::(\d{2}))?$/);
    if (!m) return NaN;
    const time=Date.UTC(+m[1],+m[2]-1,+m[3],+m[4],+m[5],+(m[6]||0)),d=new Date(time);
    return d.getUTCMonth()===+m[2]-1&&d.getUTCDate()===+m[3]&&+m[4]<24&&+m[5]<60?time:NaN;
}
function stamp(time) {
    const d=new Date(time),n=value=>String(value).padStart(2,'0');
    return {clock:`${n(d.getUTCHours())}:${n(d.getUTCMinutes())}`,date:`${n(d.getUTCDate())}/${n(d.getUTCMonth()+1)}/${d.getUTCFullYear()}`};
}
export function rainImageCaption(parameter,meta,english=false) {
    const hours=Number(/^rain(1|3|6|12|24|48|72|96|120)h$/.exec(parameter)?.[1]);
    if (!hours || Number(meta?.hours)!==hours) return null;
    const end=wallTime(meta.window?.end||meta.valid_time);
    const start=meta.window?.start?wallTime(meta.window.start):end-hours*3600000;
    if (!Number.isFinite(start)||!Number.isFinite(end)||start>=end) return null;
    const a=stamp(start),b=stamp(end);
    return {
        hours,
        title:english?`Precipitation accumulated over ${hours} ${hours===1?'hour':'hours'}`:`Precipitazione cumulata in ${hours} ${hours===1?'ora':'ore'}`,
        interval:english?`From ${a.clock} on ${a.date} to ${b.clock} on ${b.date} · Italy time`:`Dalle ${a.clock} del ${a.date} alle ${b.clock} del ${b.date} · ora italiana`,
    };
}
